import AmountDto from "../refund/AmountDto";

export const RefundAttemptStatus = {
  IN_PROGRESS: "in_progress",
  SUCCESS: "success",
  FAILED: "failed",
  EXPIRED: "expired",
} as const;

export type RefundAttemptStatusType =
  typeof RefundAttemptStatus[keyof typeof RefundAttemptStatus];

export class RefundAttemptDto {
  id: string;
  status: {
    code: RefundAttemptStatusType;
  };
  updated_at: string;
  refunded_amount: AmountDto;
  is_partial: boolean;
  should_cancel: boolean;
}
